
class CardText extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initSwiper();
    }

    initSwiper() {
        const swiperContainer = this.querySelector('.card-text__content');

        new Swiper(swiperContainer, {
            slidesPerView: "auto",
        });
    }
}

customElements.define('card-text', CardText);